import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import FileDelimitedIcon from 'mdi-react/FileDelimitedIcon'
import MicrosoftExcelIcon from 'mdi-react/MicrosoftExcelIcon'
import { twJoin } from 'tailwind-merge'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { useIsThreeStepIT } from '@/hooks/access'

import { exportDataToExcel } from '../../helpers'
import type { ReportFilters } from '../../resources'

export const OtherOptions: FC<{
  title: string
  reportsData?: Record<string, string | number | null>[]
  columnFormats?: { [key: string]: string }
  filters?: ReportFilters
}> = ({ title, reportsData, columnFormats, filters }) => {
  const translate = useTranslation()
  const isThreeStepIT = useIsThreeStepIT()

  if (!reportsData) throw Error('We have encountered a problem while loading reports')

  return (
    <div className="grid grid-cols-2">
      <Button
        Icon={<MicrosoftExcelIcon className={twJoin(!isThreeStepIT && 'text-emerald-600')} />}
        className="mb-4 ml-0"
        onClick={() =>
          exportDataToExcel(reportsData, title, {
            translate,
            columnFormats,
            fromDate: filters?.fromDate,
            toDate: filters?.toDate,
          })
        }
      >
        <Translation id="Excel" />
      </Button>
      <Button
        Icon={<FileDelimitedIcon className={twJoin(!isThreeStepIT && 'text-emerald-600')} />}
        className="mb-4 ml-0"
        onClick={() =>
          exportDataToExcel(reportsData, title, {
            extension: 'csv',
            translate,
            columnFormats,
            fromDate: filters?.fromDate,
            toDate: filters?.toDate,
          })
        }
      >
        <Translation id="CSV" />
      </Button>
    </div>
  )
}
